import PT from 'prop-types';
import styles from './styles.scss';
import InlineLoadingIndicator from './InlineLoadingIndicator';

const LoadingIndicator = ({ loadingText, children }) => (
  <div className={styles['loading-wrapper']}>
    <div className={styles['loading-text']}>{loadingText}</div>
    <div className={styles['loading-content']} />
    <div style={{ display: 'none' }}>{children}</div>
  </div>
);

LoadingIndicator.propTypes = {
  loadingText: PT.string,
  children: PT.node,
};
LoadingIndicator.defaultProps = {
  loadingText: 'Loading',
};

LoadingIndicator.Inline = InlineLoadingIndicator;

export default LoadingIndicator;
